module.exports = __webpack_public_path__ + "static/media/07.f0fd4e1f.mp3";